import { render, staticRenderFns } from "./TermOfAITaxi.vue?vue&type=template&id=86ef86f6&"
import script from "./TermOfAITaxi.vue?vue&type=script&lang=js&"
export * from "./TermOfAITaxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports